const Nieje = () => {
  return (
    <div>Takáto stránka tu žiaľ nieje!</div>
  )
}

export default Nieje